import { TasksGenerator } from 'components/elearning/tasks/tasks-generator';
import { TopicStatus } from 'components/elearning/topic-status';
import { Button } from 'components/universal/button';
import Heading from 'components/universal/heading';
import { useTopic } from 'hooks/useTopic';
import { Fragment, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { selectCanSubmitAnswer } from 'store/topic/topicSlice';
import cls from './quiz.module.scss';
import Paragraph from 'components/universal/paragraph';


export const HandHygieneQuiz = () => {
    const { t } = useTranslation('', {
        keyPrefix: 'elearning.handHygiene.quiz',
    });

    const {
        tasks,
        correctAnswer,
        isAnswerChecked,
        checkAnswers,
        isQuestionDone,
        isSuccessSendAnswer,
        totalPoints,
        obtainedPoints,
        handleTryAgainTask,
    } = useTopic();

    const [isQuizStart, setIsQuizStart] = useState(true);

    const canSubmitAnswer = useSelector(selectCanSubmitAnswer);

    const handleStartQuiz = () => setIsQuizStart(true);

    return (
        <div>
            {isQuizStart ? (
                <div className='container'>
                    <Fragment>
                        <Heading
                            headingLevel="h1"
                            className={cls.head}
                        >
                            {t('title1')}
                        </Heading>
                        <Paragraph
                            className={cls.description}
                            >
                            {t('description')}
                        </Paragraph>
                        <div className={cls.taskWrapper}>
                            <TasksGenerator
                                tasks={tasks}
                                isChecked={isAnswerChecked}
                                correctAnswer={correctAnswer}
                                isQuiz={true}
                            />
                            <div className={cls.buttonWrapper}>
                                {isSuccessSendAnswer ? (
                                    <>
                                        <div className={cls.space}></div>
                                        <TopicStatus
                                            title={
                                                isQuestionDone
                                                    ? t('titleDone')
                                                    : t('titleNotDone')
                                            }
                                            buttonText={
                                                isQuestionDone
                                                    ? t('resetQuizLabel')
                                                    : t('buttonTextNotDone')
                                            }
                                            obtainedPoints={obtainedPoints}
                                            maxScore={totalPoints}
                                            isSuccess={isQuestionDone}
                                            onSubmit={handleTryAgainTask}
                                            isQuiz={true}
                                        />
                                    </>
                                ) : (
                                    <Button
                                        className={`mx-auto ${cls.button}`}
                                        onClick={checkAnswers}
                                        disabled={!canSubmitAnswer}
                                    >
                                        {t('checkButtonText')}
                                    </Button>
                                )}
                            </div>
                        </div>
                    </Fragment>
                </div>
            ) : (
                <TopicStatus
                    title={t('topicStatusTitle')}
                    description={t('topicStatusDescription')}
                    buttonText={t('topicStatusButtonText')}
                    isSuccess
                    isStandalone
                    onSubmit={handleStartQuiz}
                />
            )}
        </div>
    );
};
